export default __webpack_public_path__ + "static/media/citynav.88eb2bc7.png";